import { CLIENT_STATUS } from '@/utils/constants/user';

export const getClients = state => state.clients.clients;
export const getActiveClients = state =>
  state.clients.clients?.filter(
    ({ subscriptionStatus }) => subscriptionStatus === CLIENT_STATUS.active,
  );
export const getIsLoadingClients = state => state.clients.isLoading;
export const getClientsError = state => state.clients.errorMessage;
